import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'
import { Theme } from '../../../features/ui/types'

interface StyledContainerProps {
  width: string
  height: string
  mode: Theme
}

export const StyledContainer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.mediaCard.item
})<StyledContainerProps>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: 2px;
  overflow: hidden;
  box-shadow: ${({ mode }) => sys[mode].elevation[200].boxShadow};
  background: transparent;

  &:hover {
    background-color: ${({ mode }) => sys[mode].interaction.onElevation.default};
  }
  &:active {
    background-color: ${({ mode }) => sys[mode].interaction.onElevation.pressed};
  }
`

export const StyledPreviewNAWording = styled.div<{ mode: Theme }>`
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
`

// Underlying background color for presenting elevation style when hover and press.
export const BackgroundColor = styled.div<StyledContainerProps>`
  background: ${({ mode }) => sys[mode].elevation[200].background};
  border-radius: 2px;
`
